module.exports = __webpack_public_path__ + "img/share.f3dbea39.png";